import { Link } from '@remix-run/react'
import { LucideBarChart4 } from 'lucide-react'
import { useState } from 'react'
import { useAdminReportsQuery } from '~/api'
import { aUser, useAtomValue } from '~/atoms'
import ReportAddToExisting from '~/components/app/map/controls/report/AddToExisting'
import { Button, Popover } from '~/components/ui'
import { Listing } from '~/models'

export default function ListingAddToReport({ listing }: { listing: Listing }) {
  const user = useAtomValue(aUser)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { reports } = useAdminReportsQuery({
    key: ['user-reports', user?._id || ''],
    find: {
      'user._id': user?._id,
      deleted: { $ne: true },
      includeIds: { $ne: null },
    },
    refetchInterval: 1000 * 15,
    enabled: !!user,
  })

  if (!user) {
    return null
  }

  return (
    <Popover open={isOpen} onOpenChange={(value) => setIsOpen(value)}>
      <Popover.Trigger asChild>
        <Button variant="outline" size="sm">
          Report
        </Button>
      </Popover.Trigger>
      <Popover.Content className="flex max-w-48 flex-col items-start gap-2 p-2">
        <Button asChild variant="ghost" size="sm" className="flex gap-2">
          <Link
            to="/admin/reports/create"
            state={{
              listingIds: [listing._id],
            }}
            onClick={(e) => {
              e.stopPropagation()
              setIsOpen(false)
            }}>
            <LucideBarChart4 className="mr-2 h-4 w-4" />
            Create New Report
          </Link>
        </Button>

        <ReportAddToExisting
          reports={reports}
          checkedListings={[listing._id]}
          buttonText="Add to Report"
          className="flex gap-2"
          showIcon={true}
          onClose={() => {
            setIsOpen(false)
          }}
        />
      </Popover.Content>
    </Popover>
  )
}
